import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api';
import { PublicApiSettingsCreateInterface, PublicApiSettingsCreatedInterface, McpSettingsCreatedInterface, McpSettingsCreateInterface, KeyTypeEnum } from '../types/public-api-settings-interface';
export const useCreateKey = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postApiKeyFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: postMcpKeyFetcher,
    isFetching: isFetchingMcpKey
  } = useFetch(t1);
  let t2;
  if ($[2] !== postApiKeyFetcher) {
    t2 = data => postApiKeyFetcher(`${PUBLIC_API_SETTINGS}`, {
      ...data,
      type: KeyTypeEnum.Api
    });
    $[2] = postApiKeyFetcher;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== postMcpKeyFetcher) {
    t3 = data_0 => postMcpKeyFetcher(`${PUBLIC_API_SETTINGS}`, {
      ...data_0,
      type: KeyTypeEnum.Mcp
    });
    $[4] = postMcpKeyFetcher;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isFetchingMcpKey || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      createApiKey: t2,
      createMcpKey: t3,
      isFetchingMcpKey
    };
    $[6] = isFetchingMcpKey;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp() {}
function _temp2() {}